import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "./components/ui/sonner";
import { AuthProvider } from "./context/AuthContext";
import { Layout } from "./components/Layout";
import { ProtectedRoute, AdminRoute, ProfileRequiredRoute } from "./components/ProtectedRoute";

import Landing from "./pages/Landing";
import Login from "./pages/Login";
import Register from "./pages/Register";
import ForgotPassword from "./pages/ForgotPassword";
import HealthProfile from "./pages/HealthProfile";
import Dashboard from "./pages/Dashboard";
import VideoLibrary from "./pages/VideoLibrary";
import PdfLibrary from "./pages/PdfLibrary";
import Pricing from "./pages/Pricing";
import AdminDashboard from "./pages/AdminDashboard";
import AdminLogin from "./pages/AdminLogin";
import Welcome from "./pages/Welcome";
import AuthCallback from "./pages/AuthCallback";
import Links from "./pages/Links";

import "./App.css";

function App() {
  return (
    <AuthProvider>
      <BrowserRouter>
        <Routes>
          {/* Hidden campaign landing — no Layout, share via direct URL */}
          <Route path="/welcome" element={<Welcome />} />
          {/* Hidden Linktree-style mobile landing */}
          <Route path="/links" element={<Links />} />
          {/* Separate admin login (no Layout, no public chrome) */}
          <Route path="/admin/login" element={<AdminLogin />} />
          {/* Google OAuth redirect target */}
          <Route path="/auth/callback" element={<AuthCallback />} />

          <Route element={<Layout />}>
            <Route path="/" element={<Landing />} />
            <Route path="/login" element={<Login />} />
            <Route path="/register" element={<Register />} />
            <Route path="/forgot-password" element={<ForgotPassword />} />
            <Route path="/pricing" element={<ProfileRequiredRoute><Pricing /></ProfileRequiredRoute>} />

            <Route path="/health-profile" element={<ProtectedRoute><HealthProfile /></ProtectedRoute>} />
            <Route path="/dashboard" element={<ProtectedRoute><Dashboard /></ProtectedRoute>} />
            <Route path="/videos" element={<ProtectedRoute><VideoLibrary /></ProtectedRoute>} />
            <Route path="/pdfs" element={<ProtectedRoute><PdfLibrary /></ProtectedRoute>} />

            <Route path="/admin" element={<AdminRoute><AdminDashboard /></AdminRoute>} />
          </Route>
        </Routes>
      </BrowserRouter>
      <Toaster position="top-right" richColors />
    </AuthProvider>
  );
}

export default App;
